export default __webpack_public_path__ + "static/wsc.8562110edc31ba723e4136a0cd485886.jpg";